// extracted by mini-css-extract-plugin
module.exports = {"text":"style-module--text--1elAY","backNav":"style-module--backNav--3s_JS"};